/** The file was automatically generated. Please do not modify manually */
import it from './online.json';
export var strings_it = it;
